import cx from 'classnames'
import React from 'react'

import { CheckboxBorderCircle } from '@cinch/oxd-components/icons/src'
import SVG from '@cinch/oxd-components/svg/src'
import tokens from '@cinch/oxd-utils/tokens/src'

const { spacing } = tokens.customProperties

interface CheckboxInputProps {
  id?: string
  label?: string
  className?: string
  [attr: string]: any
}

import * as styles from './filter-checkbox-input.module.css'

const CheckboxInput: React.FC<CheckboxInputProps> = ({ id, input, className, ...props }) => {
  const classNames = cx(styles.checkboxInput, className)

  return (
    <div className={classNames}>
      <input id={id} type="checkbox" className={styles.checkboxInputElem} {...input} {...props} />
      <SVG className={styles.checkboxInputIconBorder} children={CheckboxBorderCircle} size={spacing.m} fill="none" />
    </div>
  )
}

export default CheckboxInput
